export default __webpack_public_path__ + "static/media/receipt.mobile.bbc5afa9.svg";